'use client';

import PaginationFront from '@/components/front/ui/PaginationFront';
import Review from '@/components/front/ui/Review';
import TitleAttrSingle from '@/components/front/ui/TitleAttrSingle';
import axios from '@/lib/axios';
import { ApiRoutes } from '@/settings/routes';
import React, { Fragment, useEffect, useState } from 'react';
import Input from '@/components/ui/forms/Input';
import Textarea from '@/components/ui/forms/Textarea';
import Button from '@/components/ui/forms/Button';
import { FaCircleChevronRight } from 'react-icons/fa6';
import IputRating from '@/components/ui/forms/IputRating';
import { VscStarFull } from 'react-icons/vsc';
import Errors from '@/components/ui/alerts/Errors';
import Success from '@/components/ui/alerts/Success';
import Error from '@/components/ui/alerts/Error';
import ButtonLoading from '@/components/ui/forms/ButtonLoading';
import Select from '@/components/ui/forms/Select';
import CoverPage from '@/components/front/ui/CoverPage';
import { App_text } from '@/settings/AppText';
import LoadingFront from '@/components/front/ui/LoadingFront';
import BreadcrumbSingle from '@/components/front/ui/BreadcrumbSingle';
import Label from '@/components/ui/forms/Label';

const isBrowser = typeof window !== 'undefined';
export default function ContentCustomerReviewsPage() {
    const [loading, setLoading] = useState(true);
    const [reviews, setReviews] = useState([]);
    const [pagination, setPagination] = useState([]);
    const [paginationLinks, setPaginationLinks] = useState([]);
    const [totalStars, setTotalStars] = useState(0);
    const [error, setError] = useState('');
    const [errors, setErrors] = useState([]);
    const [success, setSuccess] = useState('');
    const [processing, setProcessing] = useState(false);
    const [processingLoadMore, setProcessingLoadMore] = useState(false);
    const [review, setReview] = useState({
        type: null,
        name: '',
        email: '',
        reason: '',
        title: '',
        comment: '',
        rating: 5,
    });

    const fetchData = async (url = ApiRoutes.API_get_all_reviews) => {
        setLoading(true);
        try {
            const res = await axios.get(url);
            if (res.data.status === 200) {
                setReviews(res.data.reviews.data);
                setPagination(res.data.reviews);
                setPaginationLinks(res.data.reviews.links);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    };

    const nextData = (url) => {
        fetchData(`${url.replace(ApiRoutes.API_ROUT, '')}`);
    };

    const prevData = (url) => {
        fetchData(`${url.replace(ApiRoutes.API_ROUT, '')}`);
    };

    const pageData = (url) => {
        fetchData(`${ApiRoutes.API_get_all_reviews}?page=${url}`);
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handelInput = (e) => {
        e.persist();

        let { name, value } = e.target;
        setReview({ ...review, [name]: value });
    };

    const submitReview = async (e) => {
        e.preventDefault();

        setProcessing(true);
        setError('');
        setErrors([]);

        axios
            .post(ApiRoutes.API_submit_customer_review, review)
            .then((res) => {
                setProcessing(false);
                if (res.data.status === 200) {
                    setSuccess(res.data.message);
                    setReview({
                        type: null,
                        name: '',
                        email: '',
                        reason: '',
                        title: '',
                        comment: '',
                        rating: 5,
                    });
                } else if (res.data.status === 401) {
                    setErrors(res.data.errors);
                } else {
                    setError('whoops!! something went wrong , please try later');
                }
            })
            .catch((error) => {
                setProcessing(false);
                if (error.response.status === 422) {
                    setError('whoops!! something went wrong , please try later');
                }
                console.log(error);
            });
    };

    return (
        <Fragment>
            <div className="flex flex-col gap-3 p-4 mb-8 border rounded-2xl md:p-6 xl:p-8">
                <div className="relative">
                    <Errors errors={errors} />
                    <Error message={error} />
                    <Success message={success} />
                    <form onSubmit={submitReview} className="flex flex-col gap-6">
                        <p className="text-base text-gray-500">{App_text.generale.text_form_reviews}</p>
                        <div className="flex items-center gap-2">
                            <p className="text-base text-gray-500">{App_text.generale.your_rating}</p>
                            <div className="flex items-center justify-start">
                                <IputRating id={1} current={review.rating} defaultChecked={review.rating === 1 ? true : false} onChange={handelInput} />
                                <IputRating id={2} current={review.rating} defaultChecked={review.rating === 2 ? true : false} onChange={handelInput} />
                                <IputRating id={3} current={review.rating} defaultChecked={review.rating === 3 ? true : false} onChange={handelInput} />
                                <IputRating id={4} current={review.rating} defaultChecked={review.rating === 4 ? true : false} onChange={handelInput} />
                                <IputRating id={5} current={review.rating} defaultChecked={review.rating === 5 ? true : false} onChange={handelInput} />
                            </div>
                        </div>
                        <div className="flex flex-col w-full gap-4 md:flex-row">
                            <div className="flex flex-col w-full gap-1 md:1/3">
                                <Label htmlFor={'name'}>Your Name</Label>
                                <Input
                                    onChange={handelInput}
                                    value={review.name}
                                    name="name"
                                    id="name"
                                    type="text"
                                    placeholder="Your Name *"
                                    required
                                    className={'text-base rounded-lg focus:!border-main-color focus:!ring-0'}
                                />
                            </div>
                            <div className="flex flex-col w-full gap-1 md:1/3">
                                <Label htmlFor={'email'}>Your Email</Label>
                                <Input
                                    onChange={handelInput}
                                    value={review.email}
                                    name="email"
                                    id="email"
                                    type="email"
                                    placeholder="Your Email *"
                                    required
                                    className={'text-base rounded-lg focus:!border-main-color focus:!ring-0'}
                                />
                            </div>
                            <div className="flex flex-col w-full gap-1 md:1/3">
                                <Label htmlFor={'reason'}>Your reason</Label>
                                <Select onChange={handelInput} value={review.reason} name="reason" id="reason" className={'text-base rounded-lg focus:!border-main-color focus:!ring-0'}>
                                    <option value="">Who did you go with?</option>
                                    <option value="business">Business</option>
                                    <option value="couples">Couples</option>
                                    <option value="family">Family</option>
                                    <option value="friends">Friends</option>
                                    <option value="solo">Solo</option>
                                </Select>
                            </div>
                        </div>
                        <div className="w-full">
                            <Label htmlFor={'title'}>Title Your Review</Label>
                            <Input
                                onChange={handelInput}
                                value={review.title}
                                name="title"
                                id="title"
                                type="text"
                                placeholder="Title Your Review"
                                className={'text-base rounded-lg focus:!border-main-color focus:!ring-0'}
                            />
                        </div>
                        <div className="w-full">
                            <Label htmlFor={'comment'}>Your Experience</Label>
                            <Textarea
                                onChange={handelInput}
                                value={review.comment}
                                name="comment"
                                placeholder="Share Your Experience *"
                                rows={5}
                                required
                                className={'text-base rounded-lg focus:border-custom-green focus:!ring-0'}
                            />
                        </div>
                        <div className="flex justify-end w-full">
                            {processing === false ? (
                                <Button type="submit" className={`flex items-center min-w-44 gap-2 text-sm font-semibold text-white transition-colors btn ounded-md group btn hover-bg`}>
                                    <span>Post Review</span>
                                    <FaCircleChevronRight className="size-4 " />
                                </Button>
                            ) : (
                                <ButtonLoading className="flex items-center justify-center px-6 py-3 h-12 w-44 rounded-sm !bg-custom-green" />
                            )}
                        </div>
                    </form>
                </div>
            </div>
            <TitleAttrSingle className="my-8">{App_text.pages.customer_reviews.secound_title}</TitleAttrSingle>
            {loading !== true ? (
                reviews.length === 0 ? (
                    <div className="text-sm text-slate-600">{App_text.generale.no_reviews}</div>
                ) : (
                    <div className="flex flex-col gap-4">
                        {reviews.map((review, index) => (
                            <Review key={index} content={review} />
                        ))}
                    </div>
                )
            ) : (
                <LoadingFront />
            )}
            {pagination !== null && paginationLinks !== null && (
                <nav className="flex flex-col justify-end mt-8 overflo-hidden lg:mt-12 sm:flex-row sm:items-center sm:justify-between">
                    <PaginationFront pagination={pagination} paginationLinks={paginationLinks} prevPage={prevData} nextPage={nextData} page={pageData} />
                </nav>
            )}
        </Fragment>
    );
}
